<template>
    <div id="paintlistforcolorpage">
        <div class="color-search">
            <div class="explanation">
                {{
                    trans('pages.paintlist_for_color.select_color_explanation')
                }}
            </div>
            <div class="field">
                <ui5-label>
                    {{ trans('pages.paintlist_for_color.selected_color') }}
                </ui5-label>
                <span v-if="colors.selected">
                    {{ getDescription(colors.selected) }}
                </span>
            </div>
            <div class="search-fields">
                <ui5-input
                    type="Text"
                    :value="colors.ralNr"
                    @input="
                        colors.ralNr = $event.target.value;
                        searchColor();
                    "
                    :placeholder="trans('pages.paintlist_for_color.ral_number')"
                />
                <ui5-input
                    type="Text"
                    :value="colors.ralType"
                    @input="
                        colors.ralType = $event.target.value;
                        searchColor();
                    "
                    :placeholder="trans('pages.paintlist_for_color.ral_type')"
                />
            </div>
            <spinner-text v-if="colors.loading">
                {{ trans('pages.paintlist_for_color.searching_colors') }}
            </spinner-text>

            <ul v-if="colors.items">
                <li
                    v-for="color in colors.items"
                    :key="color.id"
                >
                    <a
                        @click="selectColor(color)"
                        :id="color.id"
                    >
                        {{ getDescription(color) }}
                    </a>
                </li>
            </ul>
        </div>

        <div class="product-selection">
            <div class="explanation">
                {{
                    trans(
                        'pages.paintlist_for_color.product_number_explanation'
                    )
                }}
            </div>

            <div class="field">
                <ui5-input
                    type="Text"
                    :value="productNr"
                    @input="productNr = $event.target.value"
                    :placeholder="
                        trans('pages.paintlist_for_color.product_number')
                    "
                />
            </div>
        </div>

        <div class="bottom-buttons">
            <ui5-button
                @click="createPaintlist"
                :disabled="!colors.selected"
            >
                {{ trans('pages.paintlist_for_color.create') }}
            </ui5-button>
            <ui5-button @click="$router.push('/paintlistform')">
                {{ trans('pages.paintlist_for_color.cancel') }}
            </ui5-button>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import SpinnerText from '../components/loader/SpinnerText';
import optimizedPaintListApi from '../api/optimizedPaintList';
import colorApi from '../api/color';
import { showErrorMessage } from '../dialogs';
import _ from 'lodash';
import localization from '../mixins/localization';

export default {
    components: { SpinnerText },
    mixins: [localization],
    data() {
        return {
            productNr: '',
            colors: {
                items: null,
                loading: false,
                selected: null,
                ralNr: '',
                ralType: '',
            },
        };
    },
    computed: {
        searchColor() {
            return _.debounce(this.searchColorInner, 500);
        },
    },
    methods: {
        selectColor(color) {
            this.colors.selected = color;
            this.colors.items = [];
            this.colors.ralType = '';
            this.colors.ralNr = '';
        },
        getDescription(color) {
            return (
                color.ralnr +
                ' ' +
                color.raltype +
                ' ' +
                color.poedernr +
                ' ' +
                color.producent
            );
        },
        searchColorInner() {
            this.colors.loading = true;
            colorApi
                .searchByRalNrAndType(this.colors.ralNr, this.colors.ralType)
                .then((response) => {
                    this.colors.items = response.data.data;
                })
                .finally(() => {
                    this.colors.loading = false;
                });
        },
        createPaintlist() {
            optimizedPaintListApi
                .insertForColor(this.colors.selected.id, this.productNr)
                .then((response) => {
                    const paintlistId = response.data.data;
                    this.$router.push('/optimizedpaintlistview/' + paintlistId);
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.paintlist_for_color.invalid_product_number'
                        )
                    );
                });
        },
    },
};
</script>
